import React from 'react';
import { cn } from '../../lib/utils';

/**
 * Shared page title + subtitle used across redesigned app pages.
 * Presentational only — no data fetching.
 */
export default function PageHeader({ title, subtitle, actions, className }) {
  return (
    <div className={cn('flex items-start justify-between mb-6 gap-4', className)}>
      <div>
        <h1 className="text-3xl font-bold text-white mb-2 font-serif">{title}</h1>
        {subtitle ? <p className="text-muted">{subtitle}</p> : null}
      </div>
      {actions ? <div className="flex-shrink-0">{actions}</div> : null}
    </div>
  );
}
